module.exports = __webpack_public_path__ + "static/10-8fef8046f11467d9eb0877a470947229.jpg";